import { Autocomplete, TextField } from '@mui/material';
import { useGridApiContext } from '@mui/x-data-grid-premium';
import React from 'react';
import { AutocompleteOption } from '../../common/form/widgets/OptionRendererProps';

interface AutocompleteEditCellProps {
    id: string | number;
    value?: string;
    field: string;
    options: AutocompleteOption[];
    disableClearable?: boolean;
    multiple?: boolean;
    freeSolo?: boolean;
    onChange?: (
        id: string | number,
        apiRef: ReturnType<typeof useGridApiContext>,
        newValue: string
    ) => Promise<void> | void;
    'data-testid'?: string;
}

export default function AutocompleteEditCell({
    id,
    value,
    field,
    options,
    disableClearable,
    multiple,
    freeSolo,
    onChange,
    'data-testid': dataTestId
}: AutocompleteEditCellProps) {
    const apiRef = useGridApiContext();
    const handleValueChange = async (_: any, newValue) => {
        await apiRef.current.setEditCellValue({
            id,
            field,
            value: typeof newValue === 'string' ? value : newValue?.id || ''
        });
        if (onChange) {
            await onChange(id, apiRef, newValue === 'string' ? value : newValue?.id || '');
        }
    };

    return (
        <Autocomplete
            data-testid={dataTestId}
            fullWidth
            disableClearable={disableClearable}
            multiple={multiple}
            options={options}
            freeSolo={freeSolo}
            getOptionLabel={(option) => {
                const found = options.find(
                    (o: AutocompleteOption) => o.id === (option.hasOwnProperty('id') ? option.id : option)
                );
                return found ? found.label : '';
            }}
            isOptionEqualToValue={(option: AutocompleteOption, id) => {
                return option.id === id;
            }}
            value={value || ''}
            onChange={handleValueChange}
            renderInput={(params) => <TextField {...params} />}
        />
    );
}
